import { render } from "./ModelsDesktop.vue?vue&type=template&id=b855d856&scoped=true"
import script from "./ModelsDesktop.vue?vue&type=script&lang=js"
export * from "./ModelsDesktop.vue?vue&type=script&lang=js"

import "./ModelsDesktop.vue?vue&type=style&index=0&id=b855d856&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b855d856"]])

export default __exports__